import { css } from 'styled-components';
import { responsive } from '@design-system/theme';
import { POSITIONS } from '../constants';
export const getPosition = ({ parentHeight, parentWidth, theme, tooltipPosition, }) => {
    const heightMultiplied = parentHeight * 2;
    const widthDivided = parentWidth / 2;
    switch (tooltipPosition) {
        case POSITIONS.TOP:
            return css `
        transform: translate3d(0, -100%, 0);

        ${responsive('m') `
           transform: translate3d(-50%, -100%, 0);
         `}
      `;
        case POSITIONS.RIGHT:
            return css `
        transform: translate3d(0, ${heightMultiplied}px, 0);

        ${responsive('m') `
           transform: translate3d(calc(${widthDivided}px + ${theme.space[4]}px), calc(${parentHeight}px - 50%), 0);
         `}
      `;
        case POSITIONS.BOTTOM:
            return css `
        transform: translate3d(0, ${heightMultiplied}px, 0);

        ${responsive('m') `
           transform: translate3d(-50%, ${heightMultiplied}px, 0);
         `}
      `;
        case POSITIONS['BOTTOM-RIGHT']:
            return css `
        transform: translate3d(0, ${heightMultiplied}px, 0);

        ${responsive('m') `
           transform: translate3d(-${widthDivided}px, ${heightMultiplied}px, 0);
         `}
      `;
        case POSITIONS['TOP-RIGHT']:
            return css `
        transform: translate3d(0, -100%, 0);

        ${responsive('m') `
             transform: translate3d(-${widthDivided}px, -100%, 0);
           `}
      `;
        case POSITIONS.LEFT:
            return css `
        transform: translate3d(0, ${heightMultiplied}px, 0);

        ${responsive('m') `
           transform: translate3d(calc(-100% - ${widthDivided}px - ${theme.space[5]}px), calc(${parentHeight}px - 50%), 0);
         `}
      `;
        default:
            return '';
    }
};
//# sourceMappingURL=getPosition.js.map